/**
 * SourceRegistry Constants
 * Re-exports constants from individual files
 * This file should ONLY import and re-export, not define constants directly
 */

// Source type constants and utilities
export * from './sourceTypes';

// Status mapping utilities
export * from './statusMappings';

/**
 * TODO: Move these constants to separate files following the pattern above
 * These are SourceRegistry-specific configuration constants
 */

// AWS Regions for HealthImaging
export const AWS_REGIONS = [
    { value: 'us-east-1', label: 'US East (N. Virginia)' },
    { value: 'us-east-2', label: 'US East (Ohio)' },
    { value: 'us-west-2', label: 'US West (Oregon)' },
    { value: 'eu-west-1', label: 'Europe (Ireland)' },
    { value: 'eu-west-2', label: 'Europe (London)' },
    { value: 'ap-southeast-1', label: 'Asia Pacific (Singapore)' },
    { value: 'ap-southeast-2', label: 'Asia Pacific (Sydney)' },
    { value: 'ap-northeast-1', label: 'Asia Pacific (Tokyo)' },
];

// DICOM Modalities
export const DICOM_MODALITIES = [
    { value: 'CT', label: 'CT - Computed Tomography' },
    { value: 'MR', label: 'MR - Magnetic Resonance' },
    { value: 'US', label: 'US - Ultrasound' },
    { value: 'XA', label: 'XA - X-Ray Angiography' },
    { value: 'CR', label: 'CR - Computed Radiography' },
    { value: 'DX', label: 'DX - Digital Radiography' },
    { value: 'MG', label: 'MG - Mammography' },
    { value: 'NM', label: 'NM - Nuclear Medicine' },
    { value: 'PT', label: 'PT - PET' },
    { value: 'RF', label: 'RF - Radiofluoroscopy' },
    { value: 'SC', label: 'SC - Secondary Capture' },
    { value: 'OT', label: 'OT - Other' },
];

export const AUTH_TYPES = [
    { value: 'none', label: 'None' },
    { value: 'basic', label: 'Basic Authentication' },
    { value: 'bearer', label: 'Bearer Token' },
    { value: 'oauth2', label: 'OAuth 2.0' },
];

export const SCHEDULE_OPTIONS = [
    { value: null, label: 'None' },
    { value: '@hourly', label: 'Hourly' },
    { value: '@daily', label: 'Daily' },
    { value: '@weekly', label: 'Weekly' },
    { value: '@monthly', label: 'Monthly' },
];
